import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';
import { Spacing } from '@/core/tamagoshi/Spacing/Spacing';
import { Text } from '@/core/tamagoshi/Text/Text';
import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';

import type { WishlistUnit } from '../../Wishlists/interfaces';
import { returnButton } from '../../Wishlists/modules/WishlistNavigation/InteractionModal/translations';
import { ABTests } from '../abTests';
import { ListCard } from '../components/card/ListCard';
import {
  addToWishlistCreateTitle,
  addToWishlistCreateTitleRevamp,
  addToWishlistSubTitle,
  addToWishlistSubTitleRevamp,
  addToWishlistTitle,
  returnButtonRevamp,
} from '../translations';
import { useGetWishlistsData } from './useGetWishlistsData';

import style from '../fragments.module.scss';

export const useWishlistsListCard = (
  data: WishlistUnit[] | undefined,
  isFetching: boolean,
  onAddToList: (id: string | number, name: string) => void,
) => {
  const { dataWishlists, imagesLoading } = useGetWishlistsData(data);
  const [isWishlistRevampEnabled] = useBooleanFlags([
    ABTests.WISHLIST_REVAMP_ENABLED,
  ]);

  const body = (
    <>
      <Spacing type="mb" size={32}>
        <Text tag="p" className={style.subtitle}>
          {isWishlistRevampEnabled
            ? addToWishlistSubTitleRevamp
            : addToWishlistSubTitle}
        </Text>
      </Spacing>
      {isFetching || imagesLoading ? (
        <Skeleton type="paragraph" />
      ) : (
        dataWishlists?.map(({ id, name, productCount, imageUrl }, index) => (
          <ListCard
            key={`${id}${name}`}
            id={id}
            name={name}
            productCount={productCount}
            imageUrl={imageUrl}
            onClick={() => onAddToList(id, name)}
            tab={index}
          />
        ))
      )}
    </>
  );

  return {
    body,
    title: addToWishlistTitle,
    actionButtonText: isWishlistRevampEnabled
      ? addToWishlistCreateTitleRevamp
      : addToWishlistCreateTitle,
    secondaryButtonLabel: isWishlistRevampEnabled
      ? returnButtonRevamp
      : returnButton,
  };
};
